import * as api from '../api/ApiClient';
import { isFeatureFlagEnabled } from '@/services/featureFlagService';

const FILE_SYSTEM_LAG_FLAG = 'PHOS-2872_fileSystemLag404Retry';

export function sleepPromise(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Returns true only for a 403 Forbidden ApiException (insufficient permissions),
// so callers can distinguish "user is not allowed" from genuine failures
// (network errors, 5xx) that must not be silently swallowed.
export function isForbiddenError(e: unknown): boolean {
    return api.ApiException.isApiException(e) && e.status === 403;
}

export async function getFileWithRetry(client: api.FileSystemClient, path: string, content: string | null | undefined, descendants: boolean, retries = 3, delayMs = 500): Promise<api.FileSystemObjectContent> {
    const useRetryWithDelayFlag = await isFeatureFlagEnabled(FILE_SYSTEM_LAG_FLAG);
    if (!useRetryWithDelayFlag) {
        return client.getFile(path, content, descendants);
    }
        
    for (let attempt = 0; attempt < retries; attempt++) {
        try {
            return await client.getFile(path, content, descendants);
        } catch (e) {
            if (attempt < retries - 1 && api.ApiException.isApiException(e) && e.status === 404) {
                await sleepPromise(delayMs);
            } else {
                throw e;
            }
        }
    }
    throw new Error('getFileWithRetry: unreachable');
}
